// i18n area 'apps' — locale en-GB (task #171, MODELLO DELTA): NON è un
// dizionario intero. Eredita da apps.en-US.ts e sovrascrive SOLO le chiavi
// che l'inglese britannico scrive davvero in un altro modo — una chiave nuova
// nella base arriva qui gratis, e la parità si misura su base + delta.
// Contenuto: ortografia britannica (-ise/-isation, 'licence' sostantivo,
// 'catalogue', 'centre', 'enrolment') e le poche differenze lessicali reali.
// Token che NON sono prosa (il riferimento catalog/<catalog>/<file>@<digest>,
// il permesso catalog.download) restano tali e quali.
// Sidecar anti-stantie: ../meta/apps.en-GB.meta.json.
import type { DeepPartial } from '../delta'
import type { enUS } from './apps'

export const enGB: DeepPartial<typeof enUS> = {
  cts: {
    phase: {
      materializing: 'Materialising'
    }
  },
  ctTemplates: {
    importAction: 'Import from catalogue',
    importTitle: 'Import CT template from catalogue',
    importHint: 'Materialising copies the rootfs onto the chosen storage — the catalogue file stays untouched. To add new files, upload them inside a catalogue first.',
    sourceFileHint: 'The ct-rootfs files of the chosen catalogue, ready ones only',
    noFiles: 'No ready ct-rootfs file in this catalogue — upload one from the catalogue page first',
    phase: {
      materializing: 'Materialising'
    },
    exportAction: 'Export to catalogue',
    exportTitle: 'Export to catalogue',
    exportHint: 'Packs the materialised rootfs into a NEW ct-rootfs file in the chosen catalogue — the template stays untouched.'
  },
  oci: {
    importFromCatalog: 'Import from catalogue',
    importCatalogTitle: 'Import an OCI image from a catalogue',
    importCatalogHint: 'The air-gapped path: a ready oci-image archive (tar/tar.gz — docker-archive or oci-archive) is materialised into the image store with the reference catalog/<catalog>/<file>@<digest>; apps consume it like any other image. Archives are uploaded in the catalogues — this section only imports.',
    importCatalogFileHint: 'The ready oci-image files of the chosen catalogue.',
    importCatalogNoFiles: 'No ready oci-image archive in this catalogue — upload one from the catalogue detail.',
    noImages: 'No image of this repository is materialised in the cache.',
    provenanceCatalog: 'catalogue'
  }
}
